import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import customer from '../../customer';
const {isContextLoaded} = customer.selectors;

import navbar from '../../navbar';
const {NavBar} = navbar.components;

const NavLayout = ({
  children,
  contextLoaded,
  location
}) => {
  if(!contextLoaded) {
    return (
      <div className="full-width-loading">
        <div/>
      </div>
    );
  }
  
  return (
    <div id="nav-layout">
      <NavBar location={location}/>
      {children}
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    contextLoaded: isContextLoaded(state),
    location: ownProps.location.pathname    
  };
}

NavLayout.propTypes = {
  children: PropTypes.element,
  contextLoaded: PropTypes.bool.isRequired,
  location: PropTypes.string.isRequired  
};

export default connect(mapStateToProps)(NavLayout);


/** WEBPACK FOOTER **
 ** ./src/modules/app/components/NavLayout.js
 **/